import { SearchInput } from "@components/templates/SearchInput";
import { hasOwn } from "@core/utility/utility";
const { useRef, useEffect, useState, useCallback } = require("react");
import styles from "./search-with-autosuggest.module.scss";
import { Search } from "react-feather";
import Button from "@components/base/button";

const AnalyticsSearch = ({ dropdownOptions, setSelectedRows, viewTrends, currentKeyViewTrendItem, existingReqObj, search, setSearch }) => {
  const divRef = useRef(null);
  const observerRef = useRef(null);
  const [showAutosuggest, setShowAutosuggest] = useState(false);
  const [filteredResults, setFilteredResults] = useState(dropdownOptions.slice(0, 10));

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (showAutosuggest && !divRef?.current?.contains(e.target)) {
        setShowAutosuggest(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [showAutosuggest]);

  const searchHandler = (value) => {
    setSearch(value);
    let tempFilteredArr = dropdownOptions.filter((option) => option.label && option.label.toLowerCase().includes(value.toLowerCase()));
    setFilteredResults(tempFilteredArr.slice(0, 10));
  };

  const handleObserver = () => {
    const currentCount = filteredResults.length;
    const newResults = dropdownOptions.filter((option) => option.label && option.label.toLowerCase().includes(search.toLowerCase())).slice(currentCount, currentCount + 10);
    setFilteredResults((prev) => [...prev, ...newResults]);
  };

  const highlightSearchTerm = (text, searchTerm) => {
    const regex = new RegExp(searchTerm, "gi");
    const highlightedText = text.replace(regex, (match) => `<b>${match}</b>`);
    return <div dangerouslySetInnerHTML={{ __html: highlightedText }} />;
  };

  const sentinelRef = useCallback(
    (node) => {
      if (observerRef.current) observerRef.current.disconnect();

      observerRef.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          handleObserver();
        }
      });

      if (node) observerRef.current.observe(node);
    },
    [filteredResults, search]
  );

  const handleSearch = (value) => {
    if (value === "cross") {
      setSearch("");
      if (existingReqObj.auto_suggest_search !== "") viewTrends({ ...existingReqObj, auto_suggest_search: "", is_autosuggest_dropdown: false });
    } else {
      setShowAutosuggest(true);
      searchHandler(value);
    }
  };

  return (
    <div ref={divRef} className="col-md-5 px-0 d-flex">
      <SearchInput onSearchHandler={handleSearch} size="medium" placeholder={`Type to search ${currentKeyViewTrendItem?.label?.replace("", "").trim()}`} showCross={hasOwn(existingReqObj, "auto_suggest_search") && existingReqObj.auto_suggest_search !== ""} value={currentKeyViewTrendItem?.key?.includes("hs_code") && search ? +search.split("-")[0] : search} type={currentKeyViewTrendItem?.key?.includes("hs_code") ? "number" : "text"} />
      <Button
        variant="primaryWithIcon"
        size="small"
        className="ml-1 mb-3 d-flex align-items-center px-3"
        disabled={search === "" || search.length <= 1}
        onClick={() => {
          viewTrends({ ...existingReqObj, auto_suggest_search: search, is_autosuggest_dropdown: false });
          setSelectedRows([]);
        }}>
        <Search size={16} color="#ffffff" />
      </Button>
      {showAutosuggest && (
        <div className={styles.autoSuggestDropdown}>
          {filteredResults && filteredResults.length > 0 ? (
            filteredResults.map((filter) => (
              <div
                key={filter.value}
                className={`${styles.form_check} py-2 px-3`}
                onClick={() => {
                  setSelectedRows([]);
                  setSearch(filter.value.toString());
                  viewTrends({ ...existingReqObj, auto_suggest_search: filter.value.toString(), is_autosuggest_dropdown: false });
                }}>
                <span className={styles.form_check_label}>{highlightSearchTerm(filter.label, search)}</span>
              </div>
            ))
          ) : (
            <div className="py-2 px-3">
              <span className={styles.form_check_label}>No Results Found</span>
            </div>
          )}
          <div ref={sentinelRef} />
        </div>
      )}
    </div>
  );
};

export default AnalyticsSearch;
